export default __webpack_public_path__ + "media/images/paylogos/gray/mastercard-1eeee65485aa757cb9429d6cf2acf24d.png";